import { SENTRY_URL } from '../config';

let allowed = false;
let generation = 0;
let client = null;
let removeHandlers = () => {};

function safeUrl(raw) {
  try {
    const url = new URL(raw, window.location.origin);
    return url.origin + url.pathname;
  } catch { return undefined; }
}

export async function setDiagnosticsConsent(enabled) {
  allowed = enabled === true;
  const currentGeneration = ++generation;
  removeHandlers();
  removeHandlers = () => {};
  if (client) {
    client.getOptions().enabled = false;
    Promise.resolve(client.close(0)).catch(() => {});
    client = null;
  }
  if (!allowed || !SENTRY_URL) return;
  const sdk = await import('@sentry/react');
  if (!allowed || generation !== currentGeneration) return;
  sdk.init({
    dsn: SENTRY_URL,
    sendDefaultPii: false,
    defaultIntegrations: false,
    tracesSampleRate: 0,
    beforeSend(event, hint) {
      if (!allowed || generation !== currentGeneration || event.type === 'transaction') return null;
      if (/EncodingError/i.test(hint?.originalException?.message || '')) return null;
      delete event.user;
      delete event.extra;
      delete event.breadcrumbs;
      if (event.request) event.request = { url: safeUrl(event.request.url) };
      if (event.tags) event.tags = {};
      if (event.exception?.values) {
        event.exception.values.forEach(exception => exception.stacktrace?.frames?.forEach(frame => {
          if (frame.filename) frame.filename = safeUrl(frame.filename);
        }));
      }
      return event;
    },
  });
  client = sdk.getCurrentHub().getClient();
  const onError = event => {
    if (allowed && generation === currentGeneration) sdk.captureException(event.error || new Error(event.message));
  };
  const onRejection = event => {
    if (allowed && generation === currentGeneration) sdk.captureException(event.reason);
  };
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  removeHandlers = () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
